import React from 'react'
import { Table, Typography } from 'antd';

const { Text, Title } = Typography;

const columns = [
    {
        title: 'Period Type',
        dataIndex: 'periodType'
    },
    {
        title: 'Period From/To',
        dataIndex: 'periodFromTo'
    },
    {
        title: 'Amount Range',
        dataIndex: 'amountRange'
    },
    {
        title: 'Interest',
        dataIndex: 'interest'
    },
    {
        title: 'Actions',
        render: () => {
            <Text>incentives</Text>
        }
    }
];

const InterestRateChart = (props) => {

    const {interestRateChartList} = props;
  return (
    <Table
    columns={columns}
    dataSource={interestRateChartList}
    />
  )
}

export default InterestRateChart